/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_Internal_Only_DescriptionInputs */



/**
* | output |
* | --- |
* | "The AI will only answer from your linked knowledge spaces. External web search and crawling are disabled. If no relevant information is found, the AI will sa..." |
*
* @param {Rag_Internal_Only_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rag_internal_only_description = /** @type {((inputs?: Rag_Internal_Only_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Internal_Only_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die KI antwortet ausschließlich aus den verlinkten Wissensspaces. Externe Websuche und Crawling sind deaktiviert. Werden keine relevanten Informationen gefunden, teilt die KI dies mit, statt auf allgemeines Wissen zurückzugreifen.")
	return /** @type {LocalizedString} */ ("The AI will only answer from your linked knowledge spaces. External web search and crawling are disabled. If no relevant information is found, the AI will say so instead of falling back to general knowledge.")
});